// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5d310d1","453":"3108daa4","455":"a2a8f83a"}[chunkId] + ".chunk.js";
};